import { ScanApiConstant } from "../actionTypes/scan.constant";
import { Slot, scanSpeed, specimenType } from "../component/scanner/slots";
import { RegionSelectionConstants } from "../actionTypes/region_selection.constant";

const InitialState = {
}

export const previewStatusReducer = ( state = InitialState , action) => {
    const currentInfo = Object.assign({}, state[action.slot]);
    switch(action.type){
        case ScanApiConstant.INIT_PREVIEW:
            return {
                ...state,
                [action.slot] : new Slot(action.defaultConfig)
            }
        case ScanApiConstant.TAKING_PREVIEW:
            currentInfo.status = RegionSelectionConstants.GETTING_IMAGE;
            return {
                ...state, 
                [action.slot] : currentInfo
            }
        case ScanApiConstant.TAKEN_PREVIEW:
            currentInfo.status = RegionSelectionConstants.FETCHED_IMAGE;
            currentInfo.response = action.response
            currentInfo.slideName = action.response.slideName;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.REGION_SELECTION_DONE:
            currentInfo.status = RegionSelectionConstants.SELECTION_DONE;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SELECTION_CANCELLED:
            currentInfo.status = RegionSelectionConstants.FETCHED_IMAGE;
            currentInfo.region = undefined;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SELECTION_CONFIRMED:
            currentInfo.status = RegionSelectionConstants.CONFIRMED;
            currentInfo.region = action.region;
            currentInfo.actualRegion = action.actualRegion;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SPEED_CHANGE:
            currentInfo.speed = action.speed;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SPEED_CHANGE_FOR_ALL_SLOTS:
            let currentSlots = Object.assign({}, state);
            for(let k in currentSlots) {
                currentSlots[k] = Object.assign({}, currentSlots[k], {speed: action.speed});
            }
            return currentSlots;
        case ScanApiConstant.NAME_CHANGE:
            currentInfo.slideName = action.name;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.ERRORED_WHILE_TAKING_PREVIEW:
        case ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION:
            currentInfo.status = RegionSelectionConstants.ERRORED_OUT;
            currentInfo.response = action.response
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SPECIMEN_TYPE_CHANGE:
            currentInfo.specimenType = action.specimenType;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.OBJECTIVE_TYPE_CHANGE:
            currentInfo.objectiveType = action.objectiveType;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SCAN_OUTPUT_FORMAT_CHANGE:
            currentInfo.scanOutputFormat = action.scanOutputFormat;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        case ScanApiConstant.SET_DO_TILING_ONLY:
        case ScanApiConstant.UNSET_DO_TILING_ONLY:
            currentInfo.doTilingOnly = action.type === ScanApiConstant.SET_DO_TILING_ONLY;
            return {
                ...state, 
                [action.slot]: currentInfo
            }
        default :
            return state
    }
}